<template>
  <div id="application-list">
    <application-list-header/>
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="2">
          <application-list-filter-box/>
        </v-col>
        <v-col cols="12" md="10">
          <application-list-view-box/>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

export default {
  name: "ApplicationList",
  components: {
    ApplicationListHeader: () => import(
        '@/components/ApplicationListHeader'
        ),
    ApplicationListFilterBox: () => import(
        '@/components/ApplicationListFilterBox'
        ),
    ApplicationListViewBox: () => import(
        '@/components/ApplicationListViewBox'
        )
  },
}
</script>

<style scoped>

</style>
